<template>
  <div class="flex flex-col relative flex-grow h-full border-top dialog-wrapper">
    <transition name="menu-list">
      <div
        v-show="!menuActive && sequence.headlines"
        v-tooltip.right="{ content: '课程大纲' }"
        class="menu-button"
        @click.stop="handleTip"
      >
        <MenuIcon />
      </div>
    </transition>
    <div class="flex relative flex-1 overflow-y-scroll">
      <!-- msg-content -->
      <div class="h-full w-full relative flex-grow content-warpper">
        <MenuList
          :sequence="sequence"
          :scroling="scroling"
          :targetDataId="targetDataId"
          @jump="handleJump"
        />
        <!-- 重新学习按钮组 -->
        <div class="multifunction-slot">
          <slot></slot>
        </div>
        <!-- id use select-menu -->
        <div
          id="dialog-scroller"
          ref="scroller"
          class="h-full w-full overflow-y-scroll px-4 md:px-6 bg-white"
          :style="{
            'padding-top': setyleNavHeight + 'px'
          }"
        >
          <div
            v-for="(content, index) in contents"
            :key="`${content.$id}${index}`"
            :headline-type="content.headlineType"
          >
            <component
              :is="dispatch(content)"
              ref="contentConponent"
              :content="content"
              :characters="sequence.characters"
              :observer="observer"
              :isroll="callStatus.isroll"
              :utteranceInterval.sync="utteranceInterval"
              @getCurrentAvatar="getCurrentAvatar"
              @updateHistory="$emit('updateHistory')"
              @enterEditor="handleEnterEditor"
              @loaded="handleLoaded"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- msg-control -->
    <div class="control-warpper">
      <div class="control">
        <template v-if="isFestival === 'yuandan'">
          <div v-if="!progressHidden" class="yuandan-progress-bg">
            <div class="h-1 yuandan-progress" :style="progress"></div>
          </div>
        </template>
        <template v-else>
          <div v-if="!progressHidden" class="bg-motif-100">
            <div class="h-1 bg-motif" :style="progress"></div>
          </div>
        </template>

        <transition name="slide-fade" mode="out-in" @leave="leave">
          <template v-if="isPortal">
            <UtteranceControl
              :isLoading="isLoading"
              :autoPlayConfig="sequence.autoPlayConfig"
              @menu="handleTip"
              @clear="handleClear"
              @back="handleBack"
              @next="handleNext"
              @openReport="handleOpenReport"
            />
          </template>
          <template v-else>
            <component
              :is="controlDispatch(lastContent)"
              ref="control"
              :content="lastContent"
              :isLoading="isLoading"
              :characters="sequence.characters"
              :currentAvatar="currentAvatar"
              :utteranceInterval="utteranceInterval"
              :autoPlayConfig="sequence.autoPlayConfig"
              @menu="handleTip"
              @clear="handleClear"
              @back="handleBack"
              @next="handleNext"
              @openReport="handleOpenReport"
            />
          </template>
        </transition>
      </div>
    </div>
    <scorecard />
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component, Watch, Mixins } from 'vue-property-decorator';
import { Content, Frame, Sequence } from '@forchange/storytime';
import {
  Figures,
  Utterance,
  UtteranceControl,
  PhoneAuth,
  PhoneAuthControl,
  PhoneBind,
  PhoneBindControl,
  Quotation,
  ImageBlock,
  Video,
  VideoControl,
  CodeBlock,
  TidbBlock,
  RedioInput,
  TextInput,
  Iframe,
  Confetti,
  Headline,
  End,
  RedioInputControl,
  TextInputControl,
  EndControl,
  Survey,
  SurveyControl,
  SandboxControl,
  CourseFinished,
  PortalEnd,
  Portal,
  PortalControl,
  Grade,
  AnalysisReport,
  Voiceover,
  Audio,
  PracticeCourt as PracticeCourtComponent,
  UpdatePracticeCourt,
  ReviewSurver,
  Sandbox,
  CloudDesktopTurnOn,
  CloudDesktopUpload,
  Cascader,
  CascaderControl,
  CloudDesktopFileSubmit,
  Oral,
  TurnOnCamera,
  SandboxIframe,
  SQLIframe,
  SQLIframeControl,
  ChatGPTIframe,
  JupyterIframe,
  AIPaintIframe
} from '@/components/resources';
import Dispatcher from '@/pages/main/models/Dispatcher';
import Transform from './transform.vue';
import smoothscroll from 'smoothscroll-polyfill';
import scorecard from './components/scorecard/index.vue';
import { debounce } from '@/utils/throttle';
import { namespace } from 'vuex-class';
import { CallStatus, Festival, PracticeCourt } from '@/store/modules/common/types';
import MenuList from './components/menu-list';
import MenuIcon from './assets/MenuIcon.vue';
import ScrollListenMixin from '@/mixins/scrollListen';
import { IAutoPlayConfig } from './type';

const commonModal = namespace('common');

smoothscroll.polyfill();

const dispatcher = new Dispatcher({
  Utterance,
  Figures,
  Quotation,
  PhoneAuth,
  PhoneBind,
  Image: ImageBlock,
  Video,
  VideoControl,
  CodeBlock,
  RedioInput,
  RadioInput: RedioInput, // 兼容 Redio 和 Radio 两种 schema
  TextInput,
  TidbBlock,
  Iframe,
  Confetti,
  Headline,
  End,
  Survey,
  CourseFinished,
  PortalEnd,
  Portal,
  Grade,
  AnalysisReport,
  Voiceover,
  Audio,
  PracticeCourt: PracticeCourtComponent,
  UpdatePracticeCourt,
  ReviewSurver,
  Sandbox,
  CloudDesktopTurnOn,
  CloudDesktopUpload,
  CloudDesktopFileSubmit,
  Oral,
  TurnOnCamera,
  SandboxIframe,
  SQLIframe,
  Cascader,
  ChatGPTIframe,
  AIPaintIframe,
  JupyterIframe
});

const controlDispatcher = new Dispatcher({
  Utterance: UtteranceControl,
  Figures: UtteranceControl,
  Quotation: UtteranceControl,
  PhoneAuth: PhoneAuthControl,
  PhoneBind: PhoneBindControl,
  Image: UtteranceControl,
  Video: VideoControl,
  CodeBlock: UtteranceControl,
  RedioInput: RedioInputControl,
  RadioInput: RedioInputControl, // 兼容 Redio 和 Radio 两种 schema
  TextInput: TextInputControl,
  TidbBlock: UtteranceControl,
  Iframe: UtteranceControl,
  Confetti: UtteranceControl,
  Headline: UtteranceControl,
  End: EndControl,
  Survey: SurveyControl,
  CourseFinished: EndControl,
  PortalEnd: UtteranceControl,
  Portal: PortalControl,
  Sisuo: UtteranceControl,
  Grade: UtteranceControl,
  AnalysisReport: UtteranceControl,
  Voiceover: UtteranceControl,
  Audio: UtteranceControl,
  PracticeCourt: UtteranceControl,
  UpdatePracticeCourt: UtteranceControl,
  ReviewSurver: UtteranceControl,
  Sandbox: SandboxControl,
  CloudDesktopTurnOn: UtteranceControl,
  CloudDesktopUpload: UtteranceControl,
  CloudDesktopFileSubmit: UtteranceControl,
  Oral: UtteranceControl,
  Cascader: CascaderControl,
  SandboxIframe: UtteranceControl,
  SQLIframe: UtteranceControl,
  ChatGPTIframe: UtteranceControl,
  JupyterIframe: UtteranceControl,
  AIPaintIframe: UtteranceControl
});

@Component({
  components: {
    UtteranceControl,
    scorecard,
    MenuList,
    MenuIcon
  }
})
export default class Training extends Mixins(ScrollListenMixin) {
  @Prop({ type: Object }) sequence!: Sequence & {
    headlines: Array<{ title: string; level: number }>;
    progressShow?: '隐藏' | 'hidden';
    autoPlayConfig?: IAutoPlayConfig;
  };
  @Prop({ type: Object }) globalStatus: {
    isroll: Boolean;
    rollHeight: number | undefined;
  };
  @commonModal.State('callStatus') public callStatus!: CallStatus;
  @commonModal.State('practiceCourt') public practiceCourt!: PracticeCourt;
  @commonModal.State('isFestival') isFestival!: Festival;
  @commonModal.State('menuActive') menuActive: boolean;

  timer: number;
  showSidebar = false;
  isLoading = false;
  editorCode = '';

  currentAvatar = '';

  // 判断当前scroller是否在滚动
  scroling = false;

  debounceScrollToBottom = debounce(this.setScroll, 0);

  observer: IntersectionObserver | null = null;
  targetDataId: Array<string> = [];

  // Utterance连续播放使用
  utteranceInterval = 0;

  dispatch(content: Content) {
    return dispatcher.dispatch(content);
  }

  get lastContent(): Content {
    return this.sequence.contents[this.sequence.contents.length - 1];
  }

  get occurredContentSize() {
    return window.storyteller.occurredContentIds.size;
  }

  get totalContentSize() {
    return window.storyteller.totalContentIds.size || 1;
  }

  get progress(): Object {
    const lastIndex = this.sequence.contents.length - 1;
    let progress = (this.occurredContentSize / this.totalContentSize) * 100;
    if (this.sequence.contents[lastIndex]?.$kind === 'End') progress = 100;
    return {
      width: `${progress}%`
    };
  }

  get isPortal() {
    return this.$store.state.common.portalSequence.length > 0;
  }

  get progressHidden() {
    return ['隐藏', 'hidden'].includes(this.sequence.progressShow || '');
  }

  get contents() {
    let headlineType = 'empty';
    return this.sequence.contents.map((content) => {
      const temporary_content = content as Content & { title: string; headlineType: string };
      if (temporary_content.$kind === 'Headline') {
        headlineType = this.transfromId(temporary_content.title);
      }
      temporary_content.headlineType = headlineType;
      return temporary_content;
    });
  }

  mounted() {
    this.initScrollListen(this.$refs.scroller as HTMLElement);
    this.initHook();
    this.scrollToBottom();
    this.listenScroll();
    this.checkScroll();
    this.initResizeKeepCenter();
    this.storytellerAddAfterHook();
    this.hook({ content: window.storyteller.topContet });
  }

  hook(currentData: { content: Content | undefined }) {
    // 当配置全局自动播放禁用对话自动播放
    if (this.sequence.autoPlayConfig) {
      return;
    }
    // 当前仅支持Utterance
    if (!currentData || currentData.content?.$kind !== 'Utterance') return;
    const content = currentData.content as Content & {
      messages: Array<string>;
      autoPlay: undefined | '是' | true;
    };
    if (!content.autoPlay) return;
    const message = content.messages;
    // 添加是否自动配置判断
    if (message.length <= 1 || this.utteranceInterval) return;
    this.utteranceInterval = window.setInterval(() => {
      const controlComponent = this.$refs.control as Vue & { handleEnterClick: Function };
      if (!controlComponent.handleEnterClick) {
        window.clearInterval(this.utteranceInterval);
        this.utteranceInterval = 0;
        return;
      }
      controlComponent.handleEnterClick(true);
    }, 2000);
  }

  storytellerAddAfterHook() {
    window.storyteller.addHook(this.hook, 'AFTER_NEXT');
  }

  controlDispatch(content: Content & { code: string }) {
    return controlDispatcher.dispatch(content);
  }

  handleNext() {
    this.nextNotify();
    this.$store.commit('common/setCallStatus', {
      isroll: true,
      rollHeight: undefined
    });
    this.scrollToBottom();
    // 用于埋点
    this.$emit('next');
  }

  async handleBack() {
    const portalSequence = this.$store.state.common.portalSequence;
    const portalData = portalSequence[portalSequence.length - 1];
    await this.updatePracticeCourtView(undefined, portalData.practiceCourtView, true);
    this.$store.commit('common/setLoading', true);
    this.$store.commit('common/setCallStatus', {
      isroll: false,
      rollHeight: portalData.scrollTop
    });
    this.$store.commit('common/popPortal');
    this.scrollToBottom();
  }

  // 通知子组件next操作
  nextNotify() {
    const contents = this.$refs.contentConponent;
    if (!Array.isArray(contents)) return;
    (contents as Array<Vue & { nextHook?: Function }>).forEach((item) => {
      item.nextHook && item.nextHook();
    });
  }

  handleEnterEditor(code: string) {
    this.isLoading = true;
    this.editorCode = code;
  }

  // 检查元素是否在滚动
  checkScroll() {
    const scroller = this.$refs['scroller'] as HTMLDivElement;
    let timer: number;
    scroller.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = window.setTimeout(() => {
        this.scroling = false;
      }, 100);
    });
  }

  // 目录相关方法
  clickabled(title: string) {
    const headlines = this.sequence.contents.filter((item) => item.$kind === 'Headline') as Array<
      Content & { title: string; level: number }
    >;
    return headlines.some((headline: { title: string; level: number }) => headline.title === title);
  }

  transfromId(title: string) {
    return `id_${title.replace(/"/g, '_DOUBLEQUOTE_')}`;
  }

  handleTip() {
    this.$store.commit('common/setMenuActive', { menuActive: !this.menuActive });
  }

  // 目录跳转
  handleJump(headline: { title: string; level: number }) {
    if (!this.clickabled(headline.title)) return;

    const dataId = this.transfromId(headline.title);
    const scroller = this.$refs['scroller'] as HTMLDivElement;
    const rectTop =
      scroller.querySelector(`[headline-type="${dataId}"]`)?.getBoundingClientRect().top || 0;
    const scrollTop = scroller.scrollTop;

    scroller.scroll({
      top: rectTop + scrollTop,
      behavior: 'smooth'
    });
    this.scroling = true;

    window.$tracker?.outlineTrack({
      title_level: headline.level
    });
  }

  listenScroll() {
    const scroller = this.$refs['scroller'] as HTMLDivElement;

    scroller.onscroll = debounce(() => {
      const scrollerChildrens = Array.from(scroller.children) as Array<HTMLDivElement>;
      for (const child of scrollerChildrens) {
        if (child.offsetTop + child.clientHeight > scroller.scrollTop) {
          this.targetDataId = [child.getAttribute('headline-type') as string];
          return;
        }
      }
    }, 10);

    this.$once('hook:beforeDestroy', () => {
      this.observer = null;
    });
  }

  handleClearCache() {
    window.localStorage.removeItem('localWorld:' + this.$route.params.pathMatch);
    window.location.reload();
  }

  handleLoaded() {
    this.scrollToBottom();
  }

  handleClear() {
    this.$emit('clear');
  }

  handleOpenReport() {
    this.$emit('openReport');
  }

  getCurrentAvatar(avatar: string) {
    this.currentAvatar = avatar;
  }

  scrollToBottom() {
    this.$nextTick(() => {
      const scroller = this.$refs['scroller'] as HTMLDivElement;
      if (!scroller) return;
      if (this.callStatus.isroll) {
        this.debounceScrollToBottom(scroller.scrollHeight);
      } else {
        const height =
          this.callStatus.rollHeight === undefined
            ? scroller.scrollHeight
            : this.callStatus.rollHeight;
        this.debounceScrollToBottom(height, 'auto');
      }
    });
  }

  setScroll(top = 0, behavior: ScrollBehavior = 'smooth') {
    this.timer = window.setTimeout(() => {
      const scroller = this.$refs['scroller'] as HTMLDivElement;
      this.$nextTick(() => {
        scroller?.scrollTo({
          top: top,
          left: 0,
          behavior
        });
      });
      setTimeout(() => {
        this.$store.commit('common/setLoading', false);
      }, 600);
    });
  }

  initHook() {
    window.storyteller.removeHook('AFTER_CALL_END');

    window.storyteller.addHook((frame: Frame) => {
      // 排除dialogContents
      if (!frame.$kind) return;
      this.$PostConnection?.command('loading');
      // PracticeCourt视图
      this.updatePracticeCourtView(frame);

      const rollHeight = frame?.prop?.autoJump ? undefined : frame?.prop?.scrollTop;
      this.$store.commit('common/setCallStatus', {
        isroll: false,
        rollHeight
      });
      this.scrollToBottom();
    }, 'AFTER_CALL_END');
  }

  beforeDestroy() {
    clearTimeout(this.timer);
  }

  leave(el: HTMLElement, done: Function) {
    if (!Array.from(el.classList).includes('enter')) {
      done();
    }

    const transformEle = new Vue({
      render(h) {
        return h(Transform);
      }
    }).$mount().$el;

    el.innerHTML = transformEle.innerHTML;

    const transformTime = 800;
    setTimeout(() => {
      done();
    }, transformTime);
  }

  async updatePracticeCourtView(
    frame: Frame | undefined,
    practiceCourtView?: boolean,
    isBack?: Boolean
  ) {
    if (!this.practiceCourt.visible) return;
    if (!frame?.prop?.practiceCourtView && !practiceCourtView) return;
    if (!this.$PostConnection) return;
    await this.$PostConnection.command('close_double_column');
    this.$store.commit('common/setPracticeCourtVisible', false);
    this.$emit('updateHistory');

    // 减少历史记录信息
    if (isBack) return;
    window.storyteller.updateAssignContent({
      $id: this.practiceCourt.practiceCourtId,
      $kind: this.practiceCourt.practiceCourtKind,

      ...{
        SaveIframeUrl: this.practiceCourt.iframeUrl,
        userId: this.practiceCourt.userId,
        desktopOptions: this.practiceCourt.desktopOptions,
        type: this.practiceCourt.type,
        options: this.practiceCourt.options
      }
    });
  }

  // 维持元素位置
  initResizeKeepCenter() {
    window.addEventListener('resize', this.keepConter);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.keepConter);
    });
  }

  scrollerResizeChild: HTMLDivElement | undefined;
  scrollerResizeChildTimeout: number | undefined;

  keepConter() {
    this.scrollerResizeChildTimeout && clearTimeout(this.scrollerResizeChildTimeout);

    const scroller = this.$refs['scroller'] as HTMLDivElement;
    const scrollerChildrens = Array.from(scroller.children) as Array<HTMLDivElement>;
    const scrollerMidline = scroller.scrollTop + scroller.clientHeight / 2;
    for (const child of scrollerChildrens) {
      if (
        child.offsetTop <= scrollerMidline &&
        child.offsetTop + child.clientHeight >= scrollerMidline
      ) {
        if (!this.scrollerResizeChild) {
          this.scrollerResizeChild = child;
        }
        this.scrollerResizeChild.scrollIntoView({ block: 'start' });

        this.scrollerResizeChildTimeout = window.setTimeout(() => {
          this.scrollerResizeChild = undefined;
        }, 2000);

        return;
      }
    }
  }
}
</script>

<style scoped>
.dialog-wrapper {
  background: rgba(240, 241, 246, 0.6);
}

.menu-button {
  @apply hidden md:flex fixed top-20 left-0 bg-white hover:opacity-70 cursor-pointer items-center justify-center z-10;
  width: 43.2px;
  height: 40px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
}

.content-warpper {
  @apply mx-auto;
  max-width: 1200px;
}

.slide-fade-enter,
.slide-fade-leave-to {
  pointer-events: none;
}

.menu-list-enter,
.menu-list-leave-to {
  opacity: 0;
}

.menu-list-enter-active,
.menu-list-leave-active {
  transition: 0.2s;
}

.border-top {
  border-color: #f3f4f6;
  border-top-width: 1px;
}

.control-warpper {
  @apply w-full flex items-center mx-auto;
  max-width: 1200px;
}

.control {
  @apply relative bg-white w-full;
  box-shadow: 0px -5px 20px -15px rgba(0, 0, 0, 0.1);
}

/* 节日 */
.yuandan-progress-bg {
  background: #ffb6b1;
}

.yuandan-progress {
  background: #ff2a00;
}

/* slot position */
@media (min-width: 1490px) {
  .multifunction-slot {
    position: absolute !important;
    right: 0 !important;
    bottom: 0.8rem !important;
    transform: translateX(200%);
  }
}

.multifunction-slot {
  @apply fixed right-4 bottom-20 z-10;
}
</style>
